import { Button, Carousel, Divider } from 'antd';
import Icon, {
  CloseCircleOutlined,
  CloseOutlined,
  LeftCircleFilled,
  RightCircleFilled,
} from '@ant-design/icons';
import { useRef, useState } from 'react';
import style from './CenterHomePopup.module.css';
import { addSeparators } from '../../utils/format-utils.js';

const contentStyle = {
  margin: 0,
  height: '160px',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
};

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <RightCircleFilled
      onClick={onClick}
      className={style.popup_carousel_next}
    />
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <LeftCircleFilled onClick={onClick} className={style.popup_carousel_prev} />
  );
}

function CenterHomePopup(props) {
  const { feature, popup = true } = props;
  const onClose = () => {
    window.chPopup.remove();
    delete window.chPopup;
  };
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(0);

  const openLink = (id) => {
    window.open(
      ` https://www.center-home.kz/property/${id}?city_id=2`,
      '_blank'
    );
  };

  return (
    <div className={style.popup_wrapper}>
      {popup ? (
        <Button
          className={style.popup_close}
          icon={<CloseOutlined />}
          shape="circle"
          onClick={onClose}
        />
      ) : (
        ''
      )}
      {feature.properties['3d_tour'] === 'true' ? <div>3D тур</div> : ''}
      <Carousel
        ref={sliderRef}
        arrows
        infinite={false}
        // dotsClass={style.popup_dot}
        beforeChange={(oldIndex, newIndex) => setCurrent(newIndex)}
        nextArrow={
          current !==
          (Array.isArray(feature.properties.photos)
            ? feature.properties.photos
            : JSON.parse(feature.properties.photos)
          ).length -
            1 ? (
            <NextArrow />
          ) : (
            ''
          )
        }
        prevArrow={current !== 0 ? <PrevArrow /> : ''}
        appendDots={(dots) => {
          return (
            <ul
              style={{
                alignItems: 'center',
                background: '#00000033',
                padding: '2px 12px',
                borderRadius: '12px',
                insetInline: 'unset',
                width: 'unset',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            >
              {dots.map((dot, index) => {
                return (
                  <li
                    key={`${dot}-${index}`}
                    className={[
                      style.popup_dot,
                      index === current && style.popup_dot_active,
                    ].join(' ')}
                    onClick={() => sliderRef.current.goTo(index)}
                  />
                );
              })}
            </ul>
          );
        }}
      >
        {(Array.isArray(feature.properties.photos)
          ? feature.properties.photos
          : JSON.parse(feature.properties.photos)
        ).map((image, index) => {
          return (
            <img
              src={image.path}
              key={`${image.id}-${index}`}
              className={style.carousel_img}
            />
          );
        })}
      </Carousel>
      <div style={{ display: 'none' }}>bla</div>
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => openLink(feature.properties.id)}
      >
        <div className={style.popup_price}>
          <div>{addSeparators(feature.properties.price)} тг</div>
          {/* FIXNE No price_per_meter */}
          {/* <div>{`${formatNumberCompact( */}
          {/*  feature.properties.price_per_meter */}
          {/* )} тг / кв. м`}</div> */}
        </div>
        <div
          className={style.popup_text}
        >{`${feature.properties.street} ${feature.properties.house_number}`}</div>
        <div className={style.popup_text}>{feature.properties.complex}</div>
        <div className={style.popup_text}>
          {feature.properties.seller === 'owner' ? (
            <SuccessIcon />
          ) : (
            <CloseCircleOutlined style={{ color: 'red' }} />
          )}{' '}
          Хозяин недвижимости
        </div>
        <div className={style.popup_details_wrapper}>
          <div>
            <div className={style.popup_text}>
              {feature.properties.rooms} - комн.
            </div>
            <div className={style.popup_subtext}>комнатность</div>
          </div>
          <Divider type="vertical" />
          <div>
            <div className={style.popup_text}>
              {feature.properties.area % 1 !== 0
                ? feature.properties.area.toFixed(1)
                : feature.properties.area}{' '}
              м²
            </div>
            <div className={style.popup_subtext}>Площадь</div>
          </div>
          <Divider type="vertical" />
          <div>
            <div className={style.popup_text}>
              {feature.properties.kitchen_area % 1 !== 0
                ? feature.properties.kitchen_area.toFixed(1)
                : feature.properties.kitchen_area}{' '}
              м²
            </div>
            <div className={style.popup_subtext}>кухня</div>
          </div>
          <Divider type="vertical" />
          <div>
            <div className={style.popup_text}>
              {feature.properties.floor} из {feature.properties.total_floors}
            </div>
            <div className={style.popup_subtext}>этаж</div>
          </div>
        </div>
        <div className={style.popup_footer}>
          <BCCIcon />
          <div>
            <div className={style.popup_subtext}>Первоначальный взнос</div>
            <div className={style.popup_subtext_2}>
              от {addSeparators(feature.properties.initial_payment_from)} тг
            </div>
          </div>
          <div>
            <div className={style.popup_subtext}>Ежемесячный платеж</div>
            <div className={style.popup_subtext_2}>
              от {addSeparators(feature.properties.monthly_payment_from)} тг
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SuccessSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="#27ae60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.3736 7.16036L13.4669 6.10703C13.2936 5.90703 13.1536 5.5337 13.1536 5.26703V4.1337C13.1536 3.42703 12.5736 2.84703 11.8669 2.84703H10.7336C10.4736 2.84703 10.0936 2.70703 9.89358 2.5337L8.84025 1.62703C8.38025 1.2337 7.62691 1.2337 7.16025 1.62703L6.11358 2.54036C5.91358 2.70703 5.53358 2.84703 5.27358 2.84703H4.12025C3.41358 2.84703 2.83358 3.42703 2.83358 4.1337V5.2737C2.83358 5.5337 2.69358 5.90703 2.52691 6.10703L1.62691 7.16703C1.24025 7.62703 1.24025 8.3737 1.62691 8.8337L2.52691 9.8937C2.69358 10.0937 2.83358 10.467 2.83358 10.727V11.867C2.83358 12.5737 3.41358 13.1537 4.12025 13.1537H5.27358C5.53358 13.1537 5.91358 13.2937 6.11358 13.467L7.16691 14.3737C7.62691 14.767 8.38025 14.767 8.84691 14.3737L9.90025 13.467C10.1002 13.2937 10.4736 13.1537 10.7402 13.1537H11.8736C12.5802 13.1537 13.1602 12.5737 13.1602 11.867V10.7337C13.1602 10.4737 13.3002 10.0937 13.4736 9.8937L14.3802 8.84036C14.7669 8.38036 14.7669 7.62036 14.3736 7.16036ZM10.7736 6.74036L7.55358 9.96036C7.46025 10.0537 7.33358 10.107 7.20025 10.107C7.06691 10.107 6.94025 10.0537 6.84691 9.96036L5.23358 8.34703C5.04025 8.1537 5.04025 7.8337 5.23358 7.64036C5.42691 7.44703 5.74691 7.44703 5.94025 7.64036L7.20025 8.90036L10.0669 6.0337C10.2602 5.84036 10.5802 5.84036 10.7736 6.0337C10.9669 6.22703 10.9669 6.54703 10.7736 6.74036Z" />
    </svg>
  );
}
function SuccessIcon() {
  return <Icon component={SuccessSvg} />;
}

function BCCSvg() {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18089_13120)">
        <path
          d="M8.78828 1.79072L2.93918 11.3136C2.5953 11.8739 2.40949 12.5136 2.40072 13.1673C2.39194 13.8209 2.56053 14.4651 2.88924 15.0341C3.21795 15.6031 3.69502 16.0764 4.2717 16.4057C4.84837 16.7351 5.50399 16.9086 6.17157 16.9086H17.8605C18.5281 16.9086 19.1837 16.7351 19.7604 16.4057C20.3371 16.0764 20.8142 15.6031 21.1429 15.0341C21.4716 14.4651 21.6402 13.8209 21.6314 13.1673C21.6226 12.5136 21.4368 11.8739 21.0929 11.3136L15.2438 1.79072C14.9086 1.24449 14.4348 0.7925 13.8684 0.478708C13.3019 0.164916 12.6622 0 12.0114 0C11.3607 0 10.7209 0.164916 10.1545 0.478708C9.5881 0.7925 9.11424 1.24449 8.77904 1.79072M14.5512 2.21878L20.4095 11.7688C20.5986 12.0772 20.7007 12.4291 20.7055 12.7888C20.7102 13.1484 20.6173 13.5028 20.4364 13.8158C20.2554 14.1288 19.9929 14.3892 19.6755 14.5703C19.3582 14.7514 18.9974 14.8468 18.6302 14.8467H6.93196C6.56335 14.8494 6.20065 14.756 5.88115 14.576C5.56165 14.396 5.29689 14.1359 5.11411 13.8224C4.93133 13.509 4.83712 13.1535 4.84118 12.7925C4.84524 12.4316 4.94742 12.0783 5.13721 11.7688L10.9863 2.21878C11.1706 1.91785 11.4314 1.6688 11.7432 1.49589C12.0551 1.32297 12.4073 1.23209 12.7657 1.23209C13.124 1.23209 13.4763 1.32297 13.7881 1.49589C14.0999 1.6688 14.3607 1.91785 14.545 2.21878"
          fill="#DAAB6B"
        />
        <path
          d="M12.2335 4.21259L8.33614 10.5642C8.20026 10.7873 8.1271 11.0416 8.12412 11.3013C8.12113 11.561 8.18842 11.8169 8.31914 12.0429C8.44986 12.2688 8.63935 12.4569 8.86835 12.588C9.09735 12.719 9.3577 12.7883 9.62294 12.7889H17.4115C17.6768 12.7888 17.9374 12.7196 18.1665 12.5886C18.3957 12.4575 18.5852 12.2693 18.7157 12.0431C18.8462 11.8168 18.9131 11.5607 18.9095 11.3009C18.9059 11.0411 18.832 10.7869 18.6952 10.5642L14.8009 4.21259C14.6681 3.9953 14.48 3.81543 14.255 3.69054C14.03 3.56565 13.7758 3.5 13.5172 3.5C13.2586 3.5 13.0044 3.56565 12.7794 3.69054C12.5544 3.81543 12.3663 3.9953 12.2335 4.21259ZM14.7701 5.71986L17.3099 9.86182C17.3634 9.94832 17.3925 10.0472 17.3941 10.1484C17.3958 10.2495 17.3698 10.3492 17.3191 10.4373C17.2683 10.5254 17.1945 10.5987 17.1052 10.6496C17.016 10.7005 16.9145 10.7272 16.8112 10.727H11.7286C11.6257 10.7263 11.5248 10.699 11.4361 10.6478C11.3474 10.5967 11.2741 10.5236 11.2235 10.4358C11.1729 10.348 11.1468 10.2487 11.148 10.148C11.1491 10.0472 11.1774 9.94848 11.2299 9.86182L13.7727 5.71986C13.8244 5.63558 13.8975 5.56585 13.9849 5.51744C14.0723 5.46902 14.171 5.44358 14.2714 5.44358C14.3718 5.44358 14.4705 5.46902 14.5579 5.51744C14.6453 5.56585 14.7184 5.63558 14.7701 5.71986Z"
          fill="#DAAB6B"
        />
        <path
          d="M4.25855 20.5535C4.48021 20.5479 4.7005 20.5892 4.9044 20.6745C5.1083 20.7599 5.29102 20.8872 5.4401 21.048C5.74898 21.3836 5.91992 21.8193 5.91992 22.2711C5.91992 22.7229 5.74898 23.1586 5.4401 23.4942C5.28913 23.6543 5.10517 23.7811 4.9004 23.8664C4.69562 23.9516 4.4747 23.9933 4.25224 23.9887C4.0453 23.9909 3.8407 23.9457 3.65481 23.8566C3.46892 23.7676 3.30692 23.6371 3.18178 23.4757V23.9096H2.40039V19.3359H3.19945V21.0665C3.32591 20.9093 3.48776 20.7829 3.67236 20.6972C3.85695 20.6114 4.05931 20.5686 4.2636 20.5721M5.10684 22.2828C5.11381 22.024 5.01682 21.7728 4.8367 21.5832C4.74588 21.4917 4.63726 21.419 4.51725 21.3694C4.39724 21.3197 4.26828 21.2942 4.138 21.2942C4.00772 21.2942 3.87876 21.3197 3.75875 21.3694C3.63874 21.419 3.53011 21.4917 3.43929 21.5832C3.25918 21.7728 3.16218 22.024 3.16915 22.2828C3.16319 22.5449 3.25985 22.7992 3.43929 22.9936C3.62464 23.175 3.87596 23.2769 4.138 23.2769C4.40004 23.2769 4.65136 23.175 4.8367 22.9936C5.01615 22.7992 5.11281 22.5449 5.10684 22.2828Z"
          fill="#27AE60"
        />
        <path
          d="M8.14122 23.9719C7.90674 23.9794 7.67312 23.9406 7.45429 23.8577C7.23545 23.7749 7.0359 23.6498 6.86753 23.4898C6.70422 23.3287 6.57629 23.1366 6.49163 22.9253C6.40696 22.714 6.36735 22.4879 6.37522 22.2611C6.36643 22.0325 6.40621 21.8046 6.49204 21.5918C6.57787 21.379 6.70788 21.186 6.87384 21.025C7.04533 20.8644 7.24797 20.739 7.46978 20.6565C7.69159 20.5739 7.92806 20.5357 8.16521 20.5441C8.49192 20.5395 8.81382 20.6215 9.09681 20.7815C9.36812 20.9331 9.58435 21.1638 9.71536 21.4415L9.06273 21.7839C8.98724 21.6491 8.88092 21.5331 8.75207 21.4451C8.62323 21.3572 8.47536 21.2995 8.32001 21.2768C8.16466 21.2541 8.00605 21.2668 7.85657 21.314C7.70708 21.3613 7.57078 21.4417 7.4583 21.5491C7.36426 21.6415 7.29054 21.7518 7.24169 21.8732C7.19284 21.9946 7.1699 22.1245 7.17428 22.2549C7.17076 22.3845 7.19349 22.5135 7.24115 22.6344C7.28882 22.7553 7.36048 22.8658 7.45199 22.9595C7.5418 23.0524 7.65064 23.1256 7.77138 23.1744C7.89212 23.2232 8.02203 23.2464 8.15259 23.2426C8.33736 23.2445 8.51924 23.1975 8.67898 23.1066C8.83701 23.0207 8.96632 22.8919 9.05137 22.7358L9.70274 23.1066C9.55688 23.3702 9.33814 23.5883 9.07157 23.7358C8.78837 23.894 8.46725 23.9755 8.14122 23.9719Z"
          fill="#27AE60"
        />
        <path
          d="M11.8324 23.9719C11.5979 23.9794 11.3643 23.9406 11.1455 23.8577C10.9266 23.7749 10.7271 23.6498 10.5587 23.4898C10.3954 23.3287 10.2675 23.1366 10.1828 22.9253C10.0982 22.714 10.0585 22.4879 10.0664 22.2611C10.0587 22.0321 10.0996 21.8039 10.1865 21.5912C10.2734 21.3784 10.4044 21.1856 10.5713 21.025C10.7428 20.8644 10.9455 20.739 11.1673 20.6565C11.3891 20.5739 11.6256 20.5357 11.8627 20.5441C12.1894 20.5395 12.5113 20.6215 12.7943 20.7815C13.0656 20.9331 13.2819 21.1638 13.4129 21.4415L12.7514 21.7938C12.6668 21.6364 12.5397 21.5048 12.3838 21.4135C12.2279 21.3221 12.0494 21.2745 11.8678 21.2759C11.7345 21.2725 11.602 21.2957 11.4783 21.3443C11.3546 21.3929 11.2424 21.4657 11.1485 21.5583C11.0546 21.651 10.9811 21.7614 10.9324 21.8829C10.8837 22.0044 10.8609 22.1344 10.8655 22.2648C10.8618 22.3943 10.8843 22.5232 10.9318 22.6442C10.9792 22.7651 11.0506 22.8756 11.1419 22.9694C11.2317 23.0623 11.3406 23.1355 11.4613 23.1843C11.5821 23.2331 11.712 23.2563 11.8425 23.2525C12.0295 23.2521 12.2129 23.2017 12.3727 23.1066C12.5331 23.0216 12.6647 22.8928 12.7514 22.7358L13.4028 23.1066C13.2572 23.3705 13.0384 23.5886 12.7716 23.7358C12.4858 23.8955 12.1614 23.977 11.8324 23.9719Z"
          fill="#27AE60"
        />
        <path
          d="M14.2996 23.9976C14.2357 23.999 14.1723 23.9876 14.113 23.9643C14.0538 23.9409 14 23.9059 13.955 23.8616C13.909 23.8187 13.8726 23.7668 13.8483 23.7093C13.8239 23.6519 13.8121 23.59 13.8136 23.5278C13.8123 23.4669 13.8243 23.4065 13.8486 23.3504C13.873 23.2944 13.9093 23.244 13.955 23.2027C14.0006 23.1594 14.0545 23.1253 14.1137 23.1026C14.1729 23.0799 14.2361 23.069 14.2996 23.0705C14.3613 23.0689 14.4226 23.0798 14.4797 23.1026C14.5369 23.1253 14.5886 23.1594 14.6316 23.2027C14.6765 23.2446 14.7121 23.2951 14.7362 23.351C14.7603 23.4069 14.7724 23.4671 14.7717 23.5278C14.7731 23.5895 14.7619 23.6508 14.7387 23.7081C14.7155 23.7654 14.6808 23.8176 14.6366 23.8616C14.5941 23.9058 14.5426 23.9407 14.4854 23.9642C14.4282 23.9876 14.3666 23.999 14.3047 23.9976"
          fill="#27AE60"
        />
        <path
          d="M18.6366 23.9028H17.6394L16.4957 22.4751L16.2495 22.6926V23.9028H15.4492V19.3242H16.2495V21.8002L17.5346 20.632H18.5558L17.0486 21.9819L18.6366 23.9028Z"
          fill="#27AE60"
        />
        <path
          d="M21.5701 21.1547L19.8659 23.2449H21.6319V23.9013H18.7715V23.371L20.4996 21.2931H18.8573V20.6367H21.5701V21.1547Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0_18089_13120">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
function BCCIcon() {
  return <Icon component={BCCSvg} />;
}
export default CenterHomePopup;
